import requestApi from "../../../apirest";
import { toPayload } from "../utils/paymentSchedule";

/**
 * Salva as parcelas do pedido (PATCH /order/paymentSchedule). O back
 * recalcula o status: todas pagas → "paid", senão → "pendent".
 * Retorna o pedido atualizado.
 */
export async function savePaymentSchedule(orderId, schedule) {
  const response = await requestApi(
    "/order/paymentSchedule",
    { orderId, schedule: toPayload(schedule) },
    "patch",
  );
  return response.data;
}
